// import React, { useState } from 'react'
// import { Radio, Input } from 'antd';

// const { TextArea } = Input;

// const allQuestion = [
//     { "value": "Have you toured the home in person? If you have not, when is your tour scheduled? You are REQUIRED to view the home in person or have a family member tour the home on your behalf before your application can be approved." },
//     { "value": "Have you ever been convicted of a crime?" },
//     { "value": "Have you ever filed suit against a landlord?" },
//     { "value": "Have you ever been a defendant in an unlawful detainer (eviction) lawsuit or defaulted (failed to perform) any obligation of a rental agreement or lease?" },
//     { "value": "Do you have any questions about the property?" },
//     { "value": "Do you receive housing assistance such as section 8? If so, please your attach voucher on the last page of the application." },
//     { "value": "Do you have a maiden name?" },
//     { "value": "I understand that I must sign up for the Resident Benefit Package for $13 per month and provide proof of coverage that names Integrity Oklahoma LLC as additionally insured or I will be enrolled in the Renters Insurance Program." },
//     { "value": "I understand and agree that by applying to lease with this company I will have to create either a pet/animal profile or a no-pet profile using our firm’s third-party screening service. https://integrityokc.petscreening.com/ to start." },
//     { "value": "Are you currently a member of the Military? (Army, Navy, Air Force, Marines)" },
//     { "value": "I understand that if approved there will be a $75 Lease Prep fee due at lease signing." },
//     { "value": "I would like to participate in the Security Deposit Waiver program if offered on the property I am applying for. This program will charge me a monthly fee instead of requiring I pay the security deposit before move in." },

// ]


// function Questions() {
//     const [selectedOptions, setSelectedOptions] = useState([]);

//     const handleOptionChange = (questionIndex, value) => {
//         console.log("selectedOptions questionIndex", questionIndex, "selectedOptions value", value)

//         const updatedOptions = [...selectedOptions];
//         updatedOptions[questionIndex] = value;
//         setSelectedOptions(updatedOptions);

//         console.log("selectedOptions", selectedOptions)
//     }
//         return (
//             <ul>
//                 {allQuestion.map((item, index) => (
//                     <li key={index}>
//                         <p>{item.value}</p>

//                         <Radio.Group style={{ marginTop: 12 }} 
//                          value={selectedOptions[index]}
//                             onChange={(e) => handleOptionChange(index, e.target.value)}

//                         >
//                             <Radio value={1}>Yes</Radio>
//                             <Radio value={2}>No</Radio>
//                         </Radio.Group>

//                         <TextArea style={{ marginTop: 12, marginBottom: 24 }} rows={4} />
//                     </li>
//                 ))}
//             </ul>
//         )
//     }

// export default Questions;


import React, { useState } from 'react';
import { Form, Radio, Input } from 'antd';

const { TextArea } = Input;

const allQuestion = [
    { name: 'Atoured', value: 'Have you toured the home in person? If you have not, when is your tour scheduled? You are REQUIRED to view the home in person or have a family member tour the home on your behalf before your application can be approved.' },
    { name: 'Aconvicted', value: 'Have you ever been convicted of a crime?' },
    { name: 'AfiledSuit', value: 'Have you ever filed suit against a landlord?' },
    { name: 'AevictionLawsuit', value: 'Have you ever been a defendant in an unlawful detainer (eviction) lawsuit or defaulted (failed to perform) any obligation of a rental agreement or lease?' },
    { name: 'Aquestions', value: 'Do you have any questions about the property?' },
    { name: 'AhousingAssistance', value: 'Do you receive housing assistance such as section 8? If so, please attach your voucher on the last page of the application.' },
    { name: 'AmaidenName', value: 'Do you have a maiden name?' },
    { name: 'AresidentBenefitPackage', value: 'I understand that I must sign up for the Resident Benefit Package for $13 per month and provide proof of coverage that names Integrity Oklahoma LLC as additionally insured or I will be enrolled in the Renters Insurance Program.' },
    { name: 'ApetProfile', value: 'I understand and agree that by applying to lease with this company I will have to create either a pet/animal profile or a no-pet profile using our firm’s third-party screening service. https://integrityokc.petscreening.com/ to start.' },
    { name: 'AmilitaryMember', value: 'Are you currently a member of the Military? (Army, Navy, Air Force, Marines)' },
    { name: 'AleasePrepFee', value: 'I understand that if approved there will be a $75 Lease Prep fee due at lease signing.' },
    { name: 'AsecurityDepositWaiver', value: 'I would like to participate in the Security Deposit Waiver program if offered on the property I am applying for. This program will charge me a monthly fee instead of requiring I pay the security deposit before move in.' },
];

function Questions() {
    const [selectedOptions, setSelectedOptions] = useState(allQuestion.map(() => 'false'));

    const handleOptionChange = (questionIndex, value) => {
        // console.log("selectedOptions questionIndex", questionIndex, "selectedOptions value", value)

        const updatedOptions = [...selectedOptions];
        updatedOptions[questionIndex] = value;
        setSelectedOptions(updatedOptions);
    };
    //console.log("selectedOptions", selectedOptions)

    return (
        <>
            {allQuestion.map((item, index) => (
                <Form.Item key={index} name={item.name} initialValue={selectedOptions}>
                    <div>
                        <p>{item.value}</p>
                        <Radio.Group
                            style={{ marginTop: 12 }}
                            value={selectedOptions[index]}
                            onChange={(e) => handleOptionChange(index, e.target.value)}
                        >
                            <Radio value='true'>Yes</Radio>
                            <Radio value='false'>No</Radio>
                        </Radio.Group>
                        <TextArea style={{ marginTop: 12, marginBottom: 24 }} rows={4} />
                    </div>
                </Form.Item>
            ))}
        </>
    );
}

export default Questions;
